import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=25c68f9c&scoped=true&"
import script from "./conversation.vue?vue&type=script&lang=js&"
export * from "./conversation.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../assets/css/conversation.css?vue&type=style&index=0&id=25c68f9c&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "25c68f9c",
  "13a2e277"
  
)

export default component.exports